import { render, staticRenderFns } from "./TaskItemDetails.component.vue?vue&type=template&id=33f75873&scoped=true&"
import script from "./TaskItemDetails.component.vue?vue&type=script&lang=js&"
export * from "./TaskItemDetails.component.vue?vue&type=script&lang=js&"
import style0 from "./TaskItemDetails.component.vue?vue&type=style&index=0&id=33f75873&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f75873",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VDivider,VExpandTransition,VFlex,VIcon,VLayout,VRow})
